import liveswitch from "fm.liveswitch";
import { CanvasPath, ErasePath } from "./CanvasPath";
import ConnectionData from "../connection/ConnectionData";

export default class CanvasDrawing {
    public readonly events = new EventTarget();
    public readonly sendDataChannel: liveswitch.DataChannel;
    public myConnectionData?: ConnectionData;

    constructor() {
        this.sendDataChannel = new liveswitch.DataChannel("canvas-drawing");
    }

    public createReceiveDataChannel() {
        const receiveDataChannel = new liveswitch.DataChannel("canvas-drawing");
        receiveDataChannel.setOnReceive(this.onReceive.bind(this));
        return receiveDataChannel;
    }

    private onReceive(args: liveswitch.DataChannelReceiveArgs) {
        try {
            const fromConnectionId = args.getRemoteConnectionInfo().getRemoteConnectionId();
            if (fromConnectionId === this.myConnectionData!.id) {
                // Prevent a client from sending messages to itself
                return;
            }

            const message = JSON.parse(args.getDataString());

            // Use the message type as the event name
            this.events.dispatchEvent(
                new CustomEvent(message.type, { detail: message })
            );
        } catch (error) {
            console.error(error);
        }
    }

    public eraseCanvasPath(path: ErasePath) {
        const message = { type: "onpatherased", path };

        this.sendDataChannel
            .sendDataString(JSON.stringify(message))
            .then(() => {
                console.log(
                    `Sent erase for ${path.id} to ${path.toConnectionId}`
                );
            })
            .fail((ex) => {
                console.error(ex.message);
            });
    }

    public sendCanvasPath(path: CanvasPath) {
        const message = { type: "oncanvaspath", path };

        this.sendDataChannel
            .sendDataString(JSON.stringify(message))
            .then(() => {
                console.log(
                    `Sent ${path.points.length} points to ${path.toConnectionId}`
                );
            })
            .fail((ex) => {
                console.error(ex.message);
            });
    }

    public sendSyncPing(connectionId: string, timestamp: number) {
        const message = { type: "onsyncping", id: connectionId, timestamp };

        this.sendDataChannel
            .sendDataString(JSON.stringify(message))
            .fail((ex) => {
                //console.error(ex.message);
            });
    }

    public sendAllCanvasPaths(paths: CanvasPath[], toConnectionId: string) {
        const message = { type: "onsync", paths, toConnectionId };

        this.sendDataChannel
            .sendDataString(JSON.stringify(message))
            .then(() => {
                console.log(
                    `Sync ${paths.length} paths to ${toConnectionId}`
                );
            })
            .fail((ex) => {
                console.error(ex.message);
            });
    }
}
